import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { CashPosition, SuggestedAccountsResult, TreasurySettings, TreasurySettingsRequest } from '../interfaces/treasury.interface';

const E = ENDPOINTS.TREASURY;
const params = (asOf?: string, segmentId?: string) => {
  const p: Record<string, string> = {};
  if (asOf) p.asOf = asOf;
  if (segmentId) p.segmentId = segmentId;
  return p;
};

export const TreasuryService = {
  cashPosition: async (institutionId: string, asOf?: string, segmentId?: string): Promise<CashPosition> =>
    (await axios.get(E.CASH_POSITION(institutionId), { params: params(asOf, segmentId) })).data,
  cashPositionXlsx: async (institutionId: string, asOf?: string, segmentId?: string) =>
    axios.get(E.CASH_POSITION_XLSX(institutionId), { params: params(asOf, segmentId), responseType: 'blob' }),
  getSettings: async (institutionId: string): Promise<TreasurySettings> => (await axios.get(E.SETTINGS(institutionId))).data,
  saveSettings: async (body: TreasurySettingsRequest): Promise<TreasurySettings> => (await axios.put(E.SETTINGS_SAVE, body)).data,
  createSuggestedAccounts: async (institutionId: string): Promise<SuggestedAccountsResult> =>
    (await axios.post(E.SUGGESTED_ACCOUNTS(institutionId))).data,
};
